import React from "react";

const DisplayHeaders = ({ headers }) => {
  // Normalize headers into an array of { key, value } pairs
  const normalizeHeaders = (headers) => {
    if (!headers) return [];
    if (Array.isArray(headers)) return headers;
    if (typeof headers === "object" && headers !== null) {
      return Object.entries(headers).map(([key, value]) => ({ key, value }));
    }
    return [];
  };

  const safeHeaders = normalizeHeaders(headers);

  if (safeHeaders.length === 0) {
    return (
      <div style={{ margin: "0px" }}>
        <p>No headers available.</p>
      </div>
    );
  }

  return (
    <div style={{ marginTop: "0px" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "0px", marginTop: "0px",  fontFamily: "'Courier New', Courier, monospace"}}>
        {safeHeaders.map((header, index) => {
          const key = header?.key ?? "(No Key)";
          const value = header?.value ?? "(No Value)";
          return (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                gap: "10px"
              }}
            >
              <span style={{ whiteSpace: "nowrap" }}>{key}:</span>
              <span style={{ fontWeight: "bold" }}>{value}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DisplayHeaders;
